import AudioVisualizer from '../AudioVisualizer'

interface SessionHeaderProps {
  isLive: boolean
  aiSpeaking: boolean
  isTimerRunning: boolean
  formattedDuration: string
}

export function SessionHeader({
  isLive,
  aiSpeaking,
  isTimerRunning,
  formattedDuration,
}: SessionHeaderProps) {
  return (
    <div className="absolute top-0 left-0 right-0 z-20 p-4 flex justify-between items-center bg-gradient-to-b from-black/80 to-transparent pointer-events-none">
      <div className="flex items-center gap-2 pointer-events-auto bg-black backdrop-blur-md py-1.5 px-4 rounded-full border border-white/5">
        <div
          className={`w-2.5 h-2.5 rounded-full transition-colors duration-500 ${isLive ? 'bg-brand-500 shadow-[0_0_10px_#2a4742] animate-pulse' : 'bg-accent-500'}`}
        />
        <span className="text-white font-medium tracking-wide text-xs uppercase">
          {isLive ? 'Live' : 'Ready'}
        </span>
        {isTimerRunning && (
          <span className="text-white font-mono text-sm pl-3 border-l border-white/20 ml-1">
            {formattedDuration}
          </span>
        )}
      </div>

      <div className="flex items-center gap-3 bg-black backdrop-blur-md px-4 py-2 rounded-full border border-brand-500/30 pointer-events-auto shadow-lg">
        <span className="text-white font-bold text-sm">BO-SMART AI</span>
        <AudioVisualizer isActive={aiSpeaking} />
      </div>
    </div>
  )
}
